var _module = require('../../components/module.js');
var _ = require('lodash');

_module.service('$utils', [
    '$log',
    '$filter',
    '$window',
    '$state',
    '$location',

    function feedUtils($log, $filter, $window, $state, $location) {
        return {
            parseAuthQueryParam: function () {
                if($location.search() && $location.search().a) {
                    var authStr = $location.search().a;
                    var authArr = (authStr || '').split('!');
                }

                var auth = (authArr && angular.isArray(authArr) && authArr.length >= 2)
                    ? {
                        userId: authArr[0],
                        affiliateId: authArr[1]
                    }
                    : null;

                return auth;
            },

            getUserAgent: function () {
                var userAgent = ($window && $window.navigator)
                    ? $window.navigator.userAgent.toLowerCase()
                    : window.navigator.userAgent.toLowerCase();

                return userAgent;
            },

            isIosSafari: function () {
                var ua = this.getUserAgent();
                var safari = /safari/.test( ua );
                // chrome ua includes the word Safari so we check for
                // chrome and negate to make sure it's safari only
                var chrome = /crios|chrome/.test( ua );
                var ios = /iphone|ipod|ipad/.test( ua );

                return ios && safari && !chrome || false;
            },

            isStandalone: function () {
                // to check if the app is running in
                // iOS standalone mode (home screen app)

                var standalone = ($window && $window.navigator)
                    ? $window.navigator.standalone
                    : window.navigator.standalone;

                return standalone || false;
            },

            isAndroid: function () {
                var ua = this.getUserAgent();
                var android = /android/.test( ua );

                return android || false;
            }
        };
    }
]);
